import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, Text } from '@fluentui/react-components';
import { CheckmarkCircleRegular, Dismiss24Regular } from '@fluentui/react-icons';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useCommonStyles, useStores } from '../../../common/hooks';

interface EligibilitySupportModalProps {
  open: boolean;
  onCloseButtonClicked(): void;
  onConfirmButtonClicked(): void;
}

const EligibilitySupportModalImpl: React.FC<EligibilitySupportModalProps> = (props) => {
  const {
    open,
    onCloseButtonClicked,
    onConfirmButtonClicked,
  } = props;

  const {
    selectAwardPageUiStore,
  } = useStores();

  const commonStyles = useCommonStyles();

  const [isSendTicketButtonDisabled, setSendTicketButtonDisabled] = useState<boolean>(false);

  const sendTicket = (): void => {
    if (selectAwardPageUiStore.isDiscrepancyReportTicketSent) {
      return;
    }
    setSendTicketButtonDisabled(true);
    onConfirmButtonClicked();
  }

  return (
    <Dialog
      open={open}
      onOpenChange={(_, data) => {
        if (!data.open) onCloseButtonClicked();
      }}
    >
      <DialogSurface
        className={commonStyles.modalSurface}
      >
        <DialogBody className={commonStyles.modalBody}>
          <DialogTitle
            action={
              <Button
                onClick={onCloseButtonClicked}
                appearance='subtle'
                aria-label='close'
                icon={<Dismiss24Regular />}
              />
            }
          >
            Eligibility Support
          </DialogTitle>

          <DialogContent>
            <Text as='p'> Are your companies' eligibility components not appearing correctly? If you are unable to apply to an award that your company qualifies for, send a ticket to our support team for assistance.  Please submit this ticket as soon as possible to ensure this is resolved <Text weight='semibold'>before the nomination window closes on July 7th at 6:00pm PT</Text>.</Text>
            <Text
              as='p'
              block
            >
              Our support team will contact your Partner Center email contact within 48 hours.
            </Text>
          </DialogContent>

          <DialogActions>
            <Button
              disabled={isSendTicketButtonDisabled && !selectAwardPageUiStore.isDiscrepancyReportTicketSent}
              appearance='primary'
              className={`btn ${selectAwardPageUiStore.isDiscrepancyReportTicketSent ? 'sent' : ''}`}
              onClick={() => sendTicket()}
              icon={selectAwardPageUiStore.isDiscrepancyReportTicketSent ? <CheckmarkCircleRegular /> : null}
            >
              {selectAwardPageUiStore.isDiscrepancyReportTicketSent ? 'Ticket Sent' : 'Send Ticket'}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog >
  );
}

export const EligibilitySupportModal = observer(EligibilitySupportModalImpl);
